export default "__VITE_ASSET__DRY4AsFq__"